<template>
    <div>
        <v-card flat>
            <v-card-title>
                <v-row>
                    <v-col>
                        {{ $t("sales_order_validity") }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-menu
                            ref="date_from"
                            v-model="menu.date_valid_from"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    dense
                                    v-model="form.date_valid_from"
                                    :rules="rules.date_valid_from"
                                    :label="$t('date_from')"
                                    append-icon="mdi-calendar"
                                    hide-details
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker
                                :max="form.date_valid_to"
                                v-model="form.date_valid_from"
                                @input="menu.date_valid_from = false"
                                no-title
                                scrollable>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-menu
                            ref="date_from"
                            v-model="menu.date_valid_to"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    dense
                                    v-model="form.date_valid_to"
                                    :rules="rules.date_valid_to"
                                    :label="$t('date_from')"
                                    append-icon="mdi-calendar"
                                    hide-details
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="form.date_valid_to"
                                @input="menu.date_valid_to = false"
                                no-title
                                scrollable>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-btn color="primary" @click="submit" icon class="mx-2">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col>
                        <v-spacer></v-spacer>
                        <v-btn v-if="!loading.data" @click="openSalesOrderListPrintDialog()" icon class="mx-1">
                            <v-icon>mdi-printer</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="balnketSalesAgreements"
                    :loading="loading.data"
                    disable-sort
                    disable-pagination
                    hide-default-footer>
                     <template v-slot:[`item.price`]="{ item }">
                        {{ formatMoney(item.price, "SDG ", 2) }}
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <div id="printOrderList" style="display: none; font-family: 'Cairo', sans-serif" >
             <div class="row">
                <div class="col-sm">
                    <div>
                        <h4 class="text-left">Petra Ready Mixed Concrete</h4>
                        <h4 style="font-weight: bold;" class="text-left"><p>{{ $t('sales_department') }}</p></h4>
                        <p class="text-left">khartoum - sudan Industrial Area, Gabra Square.</p>
                        <p class="text-left"> +249912809360-+249187114000</p>
                    </div>
                </div>
                <div class="col-sm">
                    <img style="float: right;" class="text-right"  width="150" src="../../assets/petralogo.png" alt="">
                </div>
            </div>
            <div class="row">
                <div class="col-sm">
                    <h4 class="text-center">BSA validity report</h4>
                    <h5 class="text-center">From {{form.date_valid_from}} To {{form.date_valid_to}}</h5>
                </div>
            </div>
            <div  class="row">
                <div class="col-sm">
                    <table class="table table-bordered table-sm">
                        <thead>
                            <tr>
                                <th v-for="(header, index) in headers" :key="index">{{ header.text }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(blanket, index) in balnketSalesAgreements" :key="index">
                                <td>{{ blanket.date }}</td>
                                <td>{{ blanket.code }}</td>
                                <td>{{ blanket.customer_display_name }}</td>
                                <td>{{ blanket.validity_date }}</td>
                                <td>{{ blanket.item }}</td>
                                <td>{{ blanket.quantity }}</td>
                                <td>{{ formatMoney(blanket.price, "SDG", 2) }}</td>
                                <td>{{ blanket.sub_remaining }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import {formatMoney} from 'accounting';

import { getSalesOrderByValidityDate } from '../../services/sales/salesOrder';

export default {
    name: 'SalesOrderValidityReportPage',
    data() {
        return {
            menu: {
                date_valid_from: null,
                date_valid_to: null,
            },
            form: {
                date_valid_from: null,
                date_valid_to: null
            },
            rules: {
                date_valid_from: [],
                date_valid_to: []
            },
             headers: [
                { text: this.$t('date'), value: "date" },
                { text: this.$t("sales_order_code"), value: "code" },
                { text: this.$t("customer"), value: "customer_display_name" },
                { text: this.$t("validity"), value: "validity_date"},
                { text: this.$t("item"), value: "item"},
                { text: this.$t("quantity"), value: "quantity"},
                { text: this.$t("price"), value: "price"},
                { text: this.$t("remaining_quantity"), value: "sub_remaining"},
            ],
            balnketSalesAgreements: [],
            loading: {
                data: false
            }
        }
    },
    methods: {
        formatMoney,
      async submit() {
        this.loading.data = true;
        let response = await getSalesOrderByValidityDate({ ...this.form });
        this.balnketSalesAgreements = response.data;
        this.loading.data = false;
      },
      openSalesOrderListPrintDialog() {
        this.$htmlToPaper("printOrderList");
      }
    },
    mounted() {
        this.form.date_valid_from = moment().subtract(1, 'days').format("YYYY-MM-DD");
        this.form.date_valid_to = moment().format("YYYY-MM-DD");
    }
}
</script>